import React, { useState, useEffect } from "react";
import ShortlistedPropertyCard from "./ShortlistedPropertyCard";
import { getAllProperties } from "services";
import {
  IconTitleDescriptionActionCard,
  SectionContainerBase,
} from "@reusejs/react";
import { useSelector } from "react-redux";

let sectionDetails = {
  // title: "All of your shortlisted assets",
  title: (
    <>
      <div className="md:flex gap-x-1.5">
        <p>All of your</p> <p>shortlisted assets</p>
      </div>
    </>
  ),
  description: "",
};

export default function ShortlistedProperties() {
  const [propertiesData, setPropertiesData] = useState([]);
  const shortlistedProperties = useSelector((state: any) => {
    return state.auth?.user?.profile?.meta?.shortlisted_properties;
  });

  const getProperties = async () => {
    const data: any = await getAllProperties({
      apiConfig: {
        includeRelations: ["city", "sub_asset_type", "bank", "images"],
        includeMutations: ["state", "asset", "images"],
        includeFacets: false,
      },
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "asc" }],
      filterBy: [
        {
          attribute: "uuid",
          op: "in",
          value: shortlistedProperties ? shortlistedProperties : [],
        },
      ],
    });

    setPropertiesData(data.data);
  };

  useEffect(() => {
    getProperties();
  }, []);

  useEffect(() => {
    getProperties();
  }, [shortlistedProperties]);

  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "bg-white overflow-hidden py-10 md:py-10",
        innerContainerStyles: "max-w-7xl",
      }}
    >
      <IconTitleDescriptionActionCard
        title={sectionDetails.title}
        description={sectionDetails.description}
        itemTitleDescriptionCardBaseClasses={{
          titleWrapper: "text-left",
          titleStyles:
            "text-xl md:text-2xl font-bold	md:font-extrabold text-gray-900 md:leading-none md:tracking-tight",
          descriptionWrapper: "text-left mt-4 ",
          descriptionStyles: "max-w-2xl text-base text-gray-500",
        }}
      />
      {/* web */}
      <div className="hidden md:block">
        <div className="mt-10 h-full space-y-4">
          {propertiesData &&
            propertiesData.map((item: any, index) => (
              <ShortlistedPropertyCard
                onClick={() => console.log("Card action button clicked")}
                property={item}
                key={index}
              />
            ))}
        </div>
      </div>

      {/* mobile */}
      <div className="block md:hidden">
        <div className="w-full flex justify-center items-center">
          <div className="mt-11 h-full space-y-4 w-72">
            {propertiesData &&
              propertiesData.map((item: any, index) => (
                <ShortlistedPropertyCard
                  onClick={() => console.log("Card action button clicked")}
                  property={item}
                  key={index}
                />
              ))}
          </div>
        </div>
      </div>
    </SectionContainerBase>
  );
}
